import { Pipe, PipeTransform } from '@angular/core';

/**
 * Reads a Portfolio Characteristics money cell as the number
 * <currency-amount> needs (MR !1265 review, B1).
 *
 * facilities-api's matrix endpoint sends every cell as a string
 * (`MatrixRowResponse.values: list[str]`, "" for None), and the library's
 * `currencify` only humanizes numbers: a string reaches the screen verbatim,
 * as "$ 1500000.0 MXN".
 *
 * Returns `null`, never 0, for a cell with no amount -- LEN-2460 scenario 6
 * renders a missing amount as a dash, and `Number('')` would turn it into a
 * real-looking "$ 0.00".
 */
@Pipe({
  name: 'matrixAmount',
  standalone: true,
})
export class MatrixAmountPipe implements PipeTransform {
  transform(value: string | number | null | undefined): number | null {
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : null;
    }
    if (typeof value !== 'string' || value.trim() === '') {
      return null;
    }
    const amount = Number(value);
    return Number.isFinite(amount) ? amount : null;
  }
}
